/**
 * 최근 7일 접속 게이지 (user_visit 기반)
 * index 0 = 6일 전 ... index 6 = 오늘. 초록=접속 / 빨강=미접속.
 * BE `recentAccess: boolean[7]`를 그대로 렌더. 어드민 리워드/회원 리스트 공용.
 */
export const AccessDots = ({ access }: { access?: boolean[] }) => {
  const today = new Date();
  return (
    <span className="inline-flex items-center gap-0.5 align-middle">
      {Array.from({ length: 7 }).map((_, i) => {
        const on = access?.[i] ?? false;
        const d = new Date(today);
        d.setDate(today.getDate() - (6 - i));
        const label = `${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
        return (
          <span
            key={i}
            title={`${label} ${on ? '접속' : '미접속'}`}
            className={`w-2 h-2 rounded-full ${on ? 'bg-green-500' : 'bg-red-400'}`}
          />
        );
      })}
    </span>
  );
};
